/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetReportsSalesForecastQueryResponse,
  GetReportsSalesForecastQueryParams,
  GetReportsSalesForecast400,
} from '../types/GetReportsSalesForecast'

function getGetReportsSalesForecastUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/reports/dashboard/sales-forecast/` as const,
  }
  return res
}

/**
 * @description Forecasted revenue/volume by month plus summary cards, filtered to active (non closed-lost) deals with a resolvable close date. Returns 400 (empty body) when time_horizon is supplied but isn't one of 12/24/36.
 * @summary Reports dashboard sales forecast
 * {@link /api/v1/reports/dashboard/sales-forecast/}
 */
export async function getReportsSalesForecast(
  params: GetReportsSalesForecastQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetReportsSalesForecastQueryResponse,
    ResponseErrorConfig<GetReportsSalesForecast400>,
    unknown
  >({
    method: 'GET',
    url: getGetReportsSalesForecastUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
